import { tc } from './idioma'

const MXN = new Intl.NumberFormat('es-MX', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })
const FECHAS: Record<string, Intl.DateTimeFormat> = {}

/** Formato de fecha del idioma vigente (se crea una vez por idioma). */
function fecha(): Intl.DateTimeFormat {
  const locale = tc().locale
  return (FECHAS[locale] ??= new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }))
}

/** Importe con separadores de es-MX, sin símbolo: el código MXN se muestra aparte (componente Precio). */
export function formatearMXN(importe: number): string {
  return MXN.format(importe)
}

/** Fecha en texto («25 de septiembre de 2027»), nunca ambigua. Acepta AAAA-MM-DD. */
export function formatearFecha(iso: string): string {
  return fecha().format(new Date(`${iso.slice(0, 10)}T00:00:00Z`))
}

/** Días naturales entre hoy y la caducidad (negativo si ya caducó). */
export function diasParaCaducar(caducidadIso: string, hoy: Date = new Date()): number {
  const inicioHoy = Date.UTC(hoy.getUTCFullYear(), hoy.getUTCMonth(), hoy.getUTCDate())
  const cad = new Date(`${caducidadIso.slice(0, 10)}T00:00:00Z`).getTime()
  return Math.round((cad - inicioHoy) / 86_400_000)
}
